import React, { useEffect, useState } from 'react'
import PageHeader from '../../view/pageheader'
import TableComponent from '../CustomComponents/TableComponent'
import { Button, Card, DatePicker, Form, Input, Modal, Select, Space } from 'antd'
import { SearchOutlined, ArrowRightOutlined, RedoOutlined } from '@ant-design/icons'
import SearchComponent from '../CustomComponents/SearchComponent'
import dayjs from 'dayjs'
import { getAllBoxes } from '../../store/reducer/jobSlice'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import { getEventList } from '../../store/reducer/eventSlice';

const BoxHistory = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { getAllBoxesData } = useSelector((state) => state.jobs);
    const { eventListData, } = useSelector((state) => state.events);
    const [searchModal, setSearchModal] = useState(false)
    const [clearFilter, setClearFilter] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [searchDate, setSearchDate] = useState(null);
    const [searchValue, setSearchValue] = useState('');
    const { count: totalCount, data: tableData } = getAllBoxesData || {};
    const [searchForm] = Form.useForm();

    const columns = [
        {
            title: 'Barcode',
            dataIndex: 'barcode',
            key: 'barcode',
            align: 'center',
        },
        {
            title: 'Spec ID',
            dataIndex: 'spec_id',
            key: 'spec_id',
            align: 'center',
        },
        {
            title: 'Spec Box No',
            dataIndex: 'spec_box_number',
            key: 'spec_box_number',
            align: 'center',

        },

        {
            title: 'Stage',
            dataIndex: 'event_stage',
            key: 'event_stage',
            align: 'center',
            render: data => {
                if (data) {
                    return <span>{data}</span>
                } else {
                    return <span>Prep</span>
                }
            }

        },
        {
            title: 'Box Status',
            dataIndex: 'box_status',
            key: 'box_status',
            align: 'center',
            render: (_, record) => (
                <span
                    style={record.is_moved == 1 ? { color: 'red', fontWeight: 600 } : {}}
                >
                    {record.is_moved == 1
                        ? record?.box_status
                            ? `${record.box_status} `
                            : ''
                        : record?.box_status || ''}
                </span>


            ),

        },
        {
            title: 'Pickup Date',
            dataIndex: 'pickup_date',
            key: 'pickup_date',
            align: 'center',
            render: (data) => {
                return data ? dayjs(data).format('MM/DD/YYYY') : 'Yet to update'; // Format date to MM/DD/YYYY
            }
        },
        {
            title: 'Box State',
            key: 'box_state',
            render: (_, record) => (
                <span
                    style={record.is_moved == 1 ? { color: 'red', fontWeight: 600 } : {}}
                >
                    {record.is_moved == 1
                        ? record?.box_state
                            ? `${record.box_state} - ${record.moved_spec || ''}`
                            : ''
                        : record?.box_state || ''}
                </span>


            ),
            align: 'center',
        },
        {
            title: 'View Event History',
            key: 'action',
            align: 'center',
            render: (_, record) => (
                <Space size="middle">
                    {/* <Button className="primary-btn rounded-4">View</Button> */}
                    <Button onClick={() =>
                        navigate(`/view-event-stages-history/${window.btoa(record.barcode)}`)
                    } icon={<ArrowRightOutlined />} className="primary-btn rounded-1"></Button>
                </Space>
            ),
        }
    ]
    function getData(payload = {}) {
        dispatch(getEventList({ query: "" }));
        dispatch(getAllBoxes(payload))

    }
    useEffect(() => {
        // Fetch initial data when component mounts
        getData();
    }, []);

    const boxStatus = [
        {
            label: 'New',
            value: 'New'
        },
        {
            label: 'InComplete',
            value: 'InComplete'
        },
        {
            label: 'Completed',
            value: 'Completed'
        },
        {
            label: 'Dispositon Completed',
            value: 'Dispositon Completed'
        },
        {
            label: 'Re Assign Spec',
            value: 'Re Assign Spec'
        }

    ]
    const handleSearchClick = () => {
        if (!searchValue.trim()) {
            // If search is empty, reset to initial data
            getData({ query: "" }); // Pass empty query to fetch all data
            return;
        }
        const payloadData = {
            query: searchValue,
        };
        getData(payloadData);
        // localStorage.removeItem('barcode');
    };
    const handleCancel = () => {
        searchForm.resetFields();
        setSearchModal(false);
    };
    const handleSearch = (values) => {
        const payloadData = {
            query: values.searchText || '',
        };

        // Add pickup_date only if selected, formatting with dayjs
        if (values.searchDate) {
            payloadData.pickup_date = values.searchDate.format('MM/DD/YYYY'); // send in MM/DD/YYYY format
        }

        if (values.boxStatusValue) {
            payloadData.box_status = values.boxStatusValue;
        }

        if (values.stage) {
            payloadData.stage = values.stage
        }

        setClearFilter(true);
        getData(payloadData);
        setSearchModal(false)

        // The form fields are reset automatically on close if we call form.resetFields() in handleCancel
    };
    const eventData = eventListData?.data?.map((item) => ({
        value: item.id,
        label: item.eventname,
    }))
    return (
        <>
            <PageHeader HeaderText="Box History" Breadcrumb={[{ name: "Box History" }]} backButtonUrl="" />
            <Card style={{ marginTop: "-28px", }}
                // title="All Boxes"
                extra={
                    <>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                margin: "16px 0"
                            }}
                        >
                            {/* Left side: Search Box Number */}
                            <div style={{ display: "flex", alignItems: "left", marginRight: '350px', gap: "10px" }}>
                                <SearchComponent
                                    onChange={e => {
                                        const val = e.target.value;
                                        setSearchValue(val);

                                        if (!val.trim()) {

                                            getData({});
                                        }
                                    }}
                                    onPressEnter={handleSearchClick}
                                    style={{ width: "300px" }}
                                    placeHolder="Search Box Number"
                                />
                                <Button className="primary-btn rounded-4" onClick={handleSearchClick}>
                                    Search Box Number
                                </Button>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                                {clearFilter &&
                                    <Button
                                        icon={<RedoOutlined />}
                                        className="btn btn-danger rounded-4"
                                        shape="round"
                                        onClick={() => {
                                            setClearFilter(false);
                                            setSearchText('');
                                            setSearchDate(null);
                                            searchForm.resetFields();
                                            getData({});
                                        }
                                        }
                                    >
                                        Clear Filter
                                    </Button>
                                }
                                <Button
                                    className="primary-btn"
                                    shape="round"
                                    icon={<SearchOutlined />}
                                    type="primary"
                                    onClick={() => setSearchModal(true)}
                                >
                                    Search Filter
                                </Button>
                            </div>
                            {/* Right side: Search Filter */}


                            {/* Search Filter Modal */}
                            <Modal
                                open={searchModal}
                                onCancel={handleCancel} // Use new cancel handler to reset form
                                okText="Search"
                                // 5. Link the Modal's OK button to the Form submission
                                okButtonProps={{
                                    htmlType: 'submit', // This makes the button trigger the form's onFinish
                                    form: 'searchFilterForm', // Link it to the Form component's ID
                                }}
                                title={
                                    <span>
                                        Search Filter <SearchOutlined style={{ marginRight: 6 }} />
                                        <hr />
                                    </span>
                                }
                                width={600}
                            >
                                {/* 6. Wrap content in Ant Design Form */}
                                <Form
                                    form={searchForm} // Pass the form instance
                                    id="searchFilterForm" // Important: Give the form an ID
                                    onFinish={handleSearch} // This is called when 'Enter' is pressed in an Input or 'Search' is clicked
                                    layout="vertical"
                                    initialValues={{
                                        // Set initial values (e.g., to match external state if applicable, otherwise leave blank)
                                        searchText: '',
                                        searchDate: null,
                                        stage: null,
                                        boxStatusValue: null,
                                    }}
                                >
                                    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                                        {/* First Line: Spec */}
                                        <Form.Item
                                            label={<label style={{ marginBottom: "6px", fontWeight: "bold" }}>Search by Spec</label>}
                                            name="searchText" // Use 'name' to map to form values
                                            style={{ marginBottom: 0 }}
                                        >
                                            <Input
                                                placeholder="Enter Spec"
                                            // Removed value and onChange, Form manages them now
                                            />
                                        </Form.Item>

                                        {/* Second Line: Pickup Date */}
                                        <Form.Item
                                            label={<label style={{ marginBottom: "6px", fontWeight: "bold" }}>Pickup Date</label>}
                                            name="searchDate" // Use 'name' for DatePicker
                                            style={{ marginBottom: 0 }}
                                        >
                                            <DatePicker
                                                style={{ width: "100%" }}
                                                placeholder="Select Pickup Date"
                                                format="MM/DD/YYYY"
                                            // Removed value and onChange, Form manages them now
                                            />
                                        </Form.Item>

                                        {/* Third Line: Filter By Event Stage */}
                                        <Form.Item
                                            label={<label style={{ marginBottom: "6px", fontWeight: "bold" }}>Filter By Event Stage</label>}
                                            name="stage"
                                            style={{ marginBottom: 0 }}
                                        >
                                            <Select
                                                options={eventData}
                                                placeholder="Select Event Stage"
                                                allowClear
                                            // Removed value and onChange, Form manages them now
                                            />
                                        </Form.Item>

                                        {/* Fourth Line: Filter By Status */}
                                        <Form.Item
                                            label={<label style={{ marginBottom: "6px", fontWeight: "bold" }}>Filter By Status</label>}
                                            name="boxStatusValue"
                                            style={{ marginBottom: 0 }}
                                        >
                                            <Select
                                                options={boxStatus}
                                                placeholder="Select Box Status"
                                                allowClear
                                            // Removed value and onChange, Form manages them now
                                            />
                                        </Form.Item>
                                    </div>
                                </Form>
                            </Modal>
                        </div>



                    </>
                }
            >
                <TableComponent columns={columns} dataSource={tableData} size={"small"} />
            </Card>

        </>
    )
}

export default BoxHistory